<template>
  <BillingComponent />
</template>

<script>
// @ is an alias to /src
import BillingComponent from "@/components/Account/Pages/Billing/Billing.vue";

export default {
  name: "Billing",
  components: {
    BillingComponent
  }
};
</script>
